import React, {lazy, Suspense} from 'react';
import {withTranslation} from 'react-i18next';
import SuspenseLoader from "../../SuspenseLoader";

const MapOmegaroc = lazy(() => import('../Map/MapOmegaroc'));

const RouteMapComponent = ({screenName, items, latitude, longitude, zoom}) => {
    if (!Array.isArray(items) || items.length === 0) {
        return (<div className={"loadingWrapper"}>
            <div id="loading"/>
        </div>)
    }

    return (<div style={{height: '100%'}}>
        <Suspense fallback={<SuspenseLoader/>}>
            <MapOmegaroc items={items}
                         screenName={screenName}
                         latitude={latitude}
                         longitude={longitude}
                         zoom={zoom}
            />
        </Suspense>
    </div>);
};

export default withTranslation()(RouteMapComponent);